<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ childMsg.typeName }}管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索部分 -->
    <div class="search-bar">
      <el-form :inline="true" :model="searchUser" v-if="$store.getters['right/hasRight']('userList:addUser')">
        <el-form-item>
          <el-button type="primary" @click="showAddOrUpdateDialog(1)" plain>添加用户</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 主体部分 -->
    <el-card class="box-card">
      <search-sort-tag :sortList="sortList" :searchConditionTag="searchConditionTag" @deleteSelect="deleteSelect" @deleteSort="deleteSort"></search-sort-tag>
      <a-config-provider :locale="locale">
        <a-table :data-source="userData" :columns="childMsg.type!=='manager'?columns:columns.slice(0,4)"
                 :rowKey="(record) => record.userId"
                 bordered
                 @change="changeTable" :pagination="false"
                 :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <span slot="userToProject" slot-scope="text, record">
          <a v-if="childMsg.type != 'manager'" href="#"
             @click.prevent="toProject(record)">{{ text }}</a>
          <span v-else>{{ text }}</span>
        </span>
          <div
            slot="operation"
            slot-scope="text, record"
            v-if="childMsg.type !== 'manager'">
            <div v-if="childMsg.type !== 'manager'">
              <el-button type="primary" plain size="small" @click="showAddOrUpdateDialog(2, record.userId)"
                         v-if="$store.getters['right/hasRight']('userList:updatePwd')">
                修改密码
              </el-button>
              <el-button type="primary" plain size="small" @click="showAddOrUpdateDialog(3,record.userId)"
                         v-if="$store.getters['right/hasRight']('userList:updateUser')">
                编辑
              </el-button>
              <el-button type="danger" plain size="small" @click="hintDelete(record.userId)"
                         v-if="$store.getters['right/hasRight']('userList:delUser')">删除
              </el-button>
            </div>
            <div v-else></div>
          </div>
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
            style="padding: 8px">
            <a-input
              v-ant-ref="c => (searchInput = c)"
              :placeholder="`搜索 ${column.title}`"
              v-model="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)"/>
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
              搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">
              取消
            </a-button>
          </div>
          <a-tooltip placement="topLeft" title="搜索" slot="filterIcon" slot-scope="filtered">
            <a-icon
              type="filter"
              :style="{ color: filtered ? '#108ee9' : undefined,title:'搜索'}"/>
          </a-tooltip>
          <template slot="customRender" slot-scope="text, record, index, column">
      <span v-if="searchText && searchedColumn === column.dataIndex">
        <template
          v-for="(fragment, i) in text
            .toString()
            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
          <mark
            v-if="fragment.toLowerCase() === searchText.toLowerCase()"
            :key="i"
            class="highlight">{{ fragment }}</mark>
          <template v-else>{{ fragment }}</template>
        </template>
      </span>
            <template v-else>{{ text }}</template>
          </template>
        </a-table>
      </a-config-provider>
      <br>
      <pagination :child-msg="userPageChildMsg" @callFather="handleUserPagePagination"></pagination>
    </el-card>
    <!-- 编辑添加弹框 -->
    <el-dialog
      :title="dialogFunc == 1 ? '添加' + childMsg.typeName : dialogFunc == 2 ? '修改密码':'编辑'+ childMsg.typeName + '信息'"
      :destroy-on-close="true"
      :visible.sync="dialogVisible" width="40%">
      <el-form ref="userAddOrUpdateForm" :model="userFormData" label-width="100px" :rules="userRule">
        <el-form-item label="姓名" prop="userName" v-if="dialogFunc != 2">
          <el-input v-model.trim="userFormData.userName" :maxlength="20"
                    onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly',true);">
          </el-input>
        </el-form-item>

        <el-form-item label="手机号码" prop="userPhone" v-if="dialogFunc != 2">
          <el-input v-model.trim="userFormData.userPhone" :maxlength="15"
                    onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly',true);">
          </el-input>
        </el-form-item>
        <el-form-item label="账号密码" v-if="dialogFunc != 3" prop="userPassword">
          <el-input v-model.trim="userFormData.userPassword" show-password
                    onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly',true);"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱账号" v-if="dialogFunc != 2" prop="mail">
          <el-input v-model.trim="userFormData.mail"
                    onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly',true);"
          >
          </el-input>
        </el-form-item>
        <div v-if="childMsg.type === 'analyzer'">
          <el-form-item label="邮箱授权码" v-if="dialogFunc != 2" prop="authorizationCode">
            <el-input v-model.trim="userFormData.authorizationCode"
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addOrUpdateBefore" :disabled="addUpDisable">确 定</el-button>
            </span>
    </el-dialog>
<!--    <AntTable>-->
<!--      <template #customTitle>-->
<!--        123-->
<!--      </template>-->
<!--    </AntTable>-->
        <div class="pictureLoad" v-if="loadingUser">
          <img src="image/loading-load.gif" style="z-index:100;margin-left:50%;margin-top:18%;width: 85px ">
        </div>
    <picture-loading v-if="loadingUser"></picture-loading>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {
  checkPhoneRule,
  checkNameRule,
  checkPasswordRule,
  antdSort,
  checkMail,
  checkAuthorizationCode, checkMailOrEmpty, checkPhoneOrEmptyRule
} from '@/utils/utils.js'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import PictureLoading from "@/components/PictureLoading";
import AntTable from "@/components/AntTable";
import  {myMixins} from "@/mixins/tableOperation";
import SearchSortTag from "@/components/SearchSortTag";
import {userTransUp} from "@/utils/user";

export default {
  mixins:[myMixins],
  name: 'User',
  props: ['childMsg'],
  components: {
    'pagination': Pagination,
    'picture-loading': PictureLoading,
    'search-sort-tag':SearchSortTag,
    AntTable
  },
  // childMsg: {
  //     type: 'role',
  //     typeName: '销售',
  //     tableCols: []
  // }
  data() {
    return {
      locale: zhCN,
      loadingUser: true,
      searchUser: {
        userName: '',
        userPhone: ''
      },
      userRule: {
        userName: [{
          validator: checkNameRule,

          trigger: 'blur'
        }],
        userPhone: [{
          validator: checkPhoneOrEmptyRule,
          trigger: 'blur'
        }],
        userPassword: [{
          validator: checkPasswordRule,
          trigger: 'blur'
        }],
        mail: [{
          validator: checkMailOrEmpty,
          trigger: 'blur'
          // required: true,
        }],
        authorizationCode: [{
          validator: checkAuthorizationCode,
          trigger: 'blur'
        }]
      },
      userData: [],
      userPageChildMsg: {
        total: 0,
        pageSize: 8,
        currentNum: 1
      },
      userDataPageparm: {
        currentNum: 1,
        pageSize: 8
      },
      dialogFunc: 1, //1为添加，2为修改密码， 3为编辑
      dialogVisible: false,
      userFormData: {
        userId: 0,
        userName: '',
        userPhone: '',
        userPassword: '',
        mail: '',
        authorizationCode: '',
        role: userTransUp(this.childMsg.type)
      },
      addUpDisable: false,
      columns: [
        {
          title: '用户Id',
          dataIndex: 'userId',
          key: 'userId',
          sorter: true,
          sortDirections: ["descend", "ascend", 'descend'],

        },
        {
          title: '用户姓名',
          dataIndex: 'userName',
          key: 'userName',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          // key: 'projectsRow.projectId',
          scopedSlots: {
            customRender: 'userToProject',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            filtered: true,
          },
        },
        {
          title: '手机号码',
          dataIndex: 'userPhone',
          key: 'userPhone',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          // key: 'projectsRow.projectId',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '邮箱账号',
          dataIndex: 'email',
          key: 'email',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          // key: 'projectsRow.projectId',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '操作',
          width: 650,
          key: 'operation',
          scopedSlots: {customRender: 'operation'},
        }
      ],
    }
  },

  created: function () {
    this.getUserPageData()

  },
  methods: {
    toProject(data) {
      const {href} = this.$router.resolve({
        path: "/sampleUpload",
        query: {
          id: data.userId,
          role: this.childMsg.type,
          userName: data.userName
        },
      });
      // 新页面打开
      window.open(href, "_blank");
    },
    async showAddOrUpdateDialog(func, userId) {
      if (func != 1 && func != 2 && func != 3) {
        return
      }
      this.initUserFormDate()
      this.dialogFunc = func
      if (func == 3) {
        //编辑
        const {data: user} = await this.$http.get('user/' + userId)
        this.userFormData.userName = user.userName
        this.userFormData.userPhone = user.userPhone
        this.userFormData.userId = user.userId
        this.userFormData.mail = user.email
      } else if (func == 2) {
        // 修改密码
        this.userFormData.userPassword = ''
        this.userFormData.userId = userId
      }
      this.dialogVisible = true
    },
    initUserFormDate() {
      this.userFormData.userId = 0
      this.userFormData.userName = ''
      this.userFormData.userPassword = ''
      this.userFormData.userPhone = ''
      this.userFormData.mail = ''
      this.userFormData.authorizationCode = ''
      this.addUpDisable = false
    },
    addOrUpdateBefore() {
      const that = this
      this.$refs['userAddOrUpdateForm'].validate(valid => {
        if (valid) {
          this.addUpDisable = true
          if(this.dialogFunc===3){
            if(this.childMsg.type !== 'customer'&&!this.userFormData.userPhone){
              this.$messageUi.error('请输入手机号码')
              this.addUpDisable = false
              return
            }
            if(this.childMsg.type !== 'customer'&&!this.userFormData.userPhone){
              this.$messageUi.error('请输入手机号码')
              this.addUpDisable = false
              return
            }
            if((this.childMsg.type !== 'manager'&&this.childMsg.type !== 'auditor')&&!this.userFormData.mail){
              this.$messageUi.error('请输入邮箱账号')
              this.addUpDisable = false
            }else {
              that.addOrUpdate()
            }
          }else {
            that.addOrUpdate()
          }
        }
      })
    },
    async addOrUpdate() {
      var res
      var message
      if (this.dialogFunc == 3) {
        res = await this.$http.put('user', this.userFormData)
        message = '修改成功'
      } else if (this.dialogFunc == 1) {
        res = await this.$http.post('user', this.userFormData)
        message = '添加成功'
      } else if (this.dialogFunc == 2) {
        res = await this.$http.put('user/pw', this.userFormData)
        message = '修改成功'
      }
      if (res.code == 200) {
        this.dialogVisible = false
        if (this.dialogFunc == 1) {
          this.userDataPageparm.currentNum = 1
        }
        this.searchUser.userName = ''
        this.searchUser.userPhone = ''
        this.getUserPageData()
        this.$messageUi.success(message)
      } else {
        this.$messageUi.error(res.message)
      }
    },
    async hintDelete(userId) {
      const res = await this.$confirmUi('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (res === 'confirm') {
        this.deleteUser(userId)
      }
    },
    async deleteUser(userId) {
      var res = await this.$http.delete('user/' + userId)
      if (res.code === 200) {
        this.$messageUi.success('删除成功!')
        var divide = Math.floor(this.userPageChildMsg.total / this.userDataPageparm.pageSize)
        if (divide + 1 === this.userDataPageparm.currentNum
          && this.userPageChildMsg.total % this.userDataPageparm.pageSize === 1) {
          if (this.userDataPageparm.currentNum > 1) {
            this.userDataPageparm.currentNum--
          }
        }
        this.getUserPageData()
      } else {
        this.$messageUi.error(res.message)
      }
    },
    async getUserPageData() {
      var sendData = {
        pageNum: this.userDataPageparm.currentNum,
        pageSize: this.userDataPageparm.pageSize,
        role:userTransUp(this.childMsg.type)
      }
      let length = this.searchConditionTag.length
      if (length) {
        sendData.search = {}
        this.searchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'userName') {
            sendData.search.userName = item.value
          } else if (key === 'email') {
            sendData.search.email = item.value
          } else {
            sendData.search.userPhone = item.value
          }
        })
      } else {
        sendData.search = {}
      }
      sendData.sorts = this.selectSort
      if (this.searchUser.userName) {
        sendData.search.userName = this.searchUser.userName
      }
      if (this.searchUser.userPhone) {
        sendData.search.userPhone = this.searchUser.userPhone
      }
      const res = await this.$http.post('user/public/page', sendData)
      this.loadingUser = false
      if (res.code == 200) {
        const pageData = res.data
        // console.log(pageData);
        this.userData = pageData.data
        this.userPageChildMsg.total = pageData.totalNum
        this.userPageChildMsg.pageSize = pageData.pageSize
        this.userPageChildMsg.currentNum = pageData.currentNum
      }

    },
    handleUserPagePagination(pageparm) {
      this.loadingUser = true
      this.userDataPageparm = pageparm
      this.getUserPageData()
    },
    //mixin
    addLoading(){
      this.loadingUser = true
    },
    updatePageDataBySearch(){
      this.userDataPageparm.currentNum = 1
      this.getUserPageData()
    },
    updatePageData(){
      this.getUserPageData()
    }
  }
}
</script>

<style scoped>
.search-bar {
  margin-top: 20px;
}

::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.pictureLoad {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  z-index: 99;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}

::v-deep.ant-table td {
  white-space: nowrap;
}
</style>
